import { ENV_VARS, findReverseProxyURL } from '../constants/config';

export const getEnv = (value) => {
  return process.env[value];
};

const isExternalWithReverseProxy = findReverseProxyURL();
export const getServerUrl = () =>  isExternalWithReverseProxy ? '/'+isExternalWithReverseProxy : getEnv(ENV_VARS.REACT_APP_API_GATEWAY_URL);
export const getAPIKey = () => getEnv(ENV_VARS.REACT_APP_API_GATEWAY_SUBSCRIPTION_KEY);
export const getSmartSheetUrl = () => getEnv(ENV_VARS.REACT_APP_OPEN_SMART_SHEET_URL);

export const getApiHeaders = () => ({
  'Content-Type': 'application/json; charset=utf-8 ',
  'access-control-allow-origin': '*',
  'Ocp-Apim-Subscription-Key': getAPIKey(),
  'X-Frame-Options': 'same-origin',
  'X-Content-Type-Options': 'nosniff',
});
